import { ReactComponentManifest } from "web/entrypoints/common/setup";
import Footer from "web/react/components/footer/footer";
import ClassicFooter from "web/react/components/classic-footer/classic-footer";
import ClassicHomepageLayout from "web/react/components/classic-homepage-layout/classic-homepage-layout";
import HomepageOverlay from "web/react/components/homepage-overlay/homepage-overlay";

const components: ReactComponentManifest = {
    Footer,
    ClassicFooter,
    ClassicHomepageLayout,
    HomepageOverlay,
};

export default components;
